import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private theme = new BehaviorSubject('deep-blue');

  private themeList = [
    /*"deep-blue",
    "light-blue",
    "light-teal",
    "deep-teal",
    "deep-purple",
    "light-purple",
    "deep-red",
    "light-pink",
    "deep-pink",
    "deep-green",
    "lime",
    "deep-yellow",
    "light-yellow",
    "deep-orange",
    "light-orange",
    "deep-brown",
    "light-brown",
    "light-gray",
    "deep-gray",
    "light-silver",
    "deep-silver",*/

    "yellow-theme",
    "orange-theme",
    "red-theme",
    "pink-theme",
    "purple-theme",
    "sky-theme",
    "teal-theme",
    "blue-theme",
    "green-theme",
    "dark-theme"
  ];

  constructor() {}

  getList(): string[] {
    return this.themeList;
  }

  getTheme(): Observable<string> {
    return this.theme.asObservable();
  }

  setTheme(theme: string) {
    let vTheme = (theme.search('-theme')>=0) ? theme : theme + '-theme';
    if(this.themeList.filter(t => t == vTheme).length>0) {
      this.theme.next(vTheme);
    } else {
      console.error('String não é referente a nenhum tema valido na lista retornada por getThemes()');
    }
  }

}
